<template>
    <div class="bg-white my-4 p-3" v-if="this.products.length">
        <h5 class="mb-3">{{$t('prodotti_suggeriti')}}</h5>
        <inc-product-list :products="this.products"/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {getProductsListByFilter} from '../../api/restaurant';
    import {getUsableProducts} from '../../libraries/utils';

    import IncProductList from '../menu/partials/IncProductList';

    export default {
        name: "IncSuggestedProducts",
        components: {IncProductList},
        props: ['suggestedProducts', 'blacklistedProducts'],
        data() {
            return {
                products: []
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            suggested_products: function () {
                if (this.suggestedProducts.length > 3) {
                    //Filtriamo i doppioni
                    const suggested_products = this.suggestedProducts.filter((v, i) => {
                        return this.suggestedProducts.indexOf(v) === i;
                    });

                    const ids_random = [];
                    if (suggested_products.length) {
                        for (let i = 0; i < 3; i++) {
                            let index = Math.floor(Math.random() * suggested_products.length);
                            ids_random.push(suggested_products[index]);
                        }
                    }

                    return ids_random;
                }

                return this.suggestedProducts;
            },
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            }),
            ...mapState('order', {
                order: state => state
            }),
            ...mapState('localization', {
                language: state => state.language
            })
        },
        watch: {
            language: function () {
                this.fetch();
            }
        },
        methods: {
            fetch: function () {
                getProductsListByFilter(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_menu: this.order.id_menu,
                    id_locale: this.locale.id,
                    ids_prodotti_suggeriti: this.suggested_products,
                    ids_prodotti_blacklist: this.blacklistedProducts
                }).then((response) => {
                    this.products = getUsableProducts(response.prodotti, this.locale.id, this.order.type);
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                })
            }
        }
    }
</script>
